import React from "react";
import PageTitle from "../../../components/PageTitle/PageTitle";
import '../../../../node_modules/react-vis/dist/style.css';
import Cookies from "universal-cookie";


const cookies = new Cookies();
const username = cookies.get('username', { path: '/' });
const token = cookies.get('token', { path: '/' });
export default class DashboardMagazzino extends React.Component {

  constructor(props){
    super (props);

    this.state = {

    }

  }

  async reload(start, end) {
    
  }

  async componentDidMount(){

    await this.reload();
  }


  render () {

    return (
      <>
        <PageTitle title={'Dashboard'} />  
      </>
    );
  }
}

const dashboardView = {
  backgroundColor: 'white', 
  borderRadius: 10, 
  padding: 30,
  marginBottom: 10,
  height: '100%', 
  width: '100%',
  overflow: 'hidden',
  boxShadow: '0px 2px 4px lightgrey'
}

const inputStyle = {
  borderRadius: 4,
  width: '80%',
  paddingTop: 9,
  paddingBottom: 9,
  paddingInline: 9,
  outlineColor: '#4A4A4A',
  outlineWidth: "thin"
}

const smallInputStyle = {
  borderRadius: 4,
  width: '20%',
  marginLeft: 5,
  paddingTop: 9,
  paddingBottom: 9,
  paddingInline: 9,
  outlineColor: '#4A4A4A',
  outlineWidth: "thin"
}